"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var questions = screenersImport.expandscreeners([{
  prompt: "This questionnaire is similar to the one you completed at the beginning of the program. " + "It will measure your current stress and wellbeing levels, and compare it against global averages. " + "We hope you found the program helpful. This data is stored securely and confidentially.",
  type: "multi",
  options: {
    options: [],
    reversed: false
  },
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, utils.screeners.PSS_DEPRECATED, utils.screeners.ROI_HPQ_3, utils.screeners.WHO5, utils.screeners.workplaceQuestionnaire5, // NPS
{
  prompt: "How likely are you to recommend your company to a friend as a great place to work?",
  extraText: "",
  type: "multi",
  options: ["0 - Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "10 - Extremely likely"],
  key: "npsWork",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, // Work-life balance indicators
{
  prompt: "Please rate the quality of your sleep over the last week.",
  extraText: "",
  type: "multi",
  options: ["0 - Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "10 - Best possible sleep"],
  key: "sleepQuality",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, {
  prompt: "How many hours did you work in the last week?",
  extraText: "",
  type: "multi",
  options: ["0-10", "10-20", "20-30", "30-40", "40-50", "50-60", "60-70", "70-80", "80-90", "90+"],
  key: "hoursWorkedLastWeek",
  eval: function _eval(n) {
    return 5 + 10 * n;
  },
  batteryId: "survey"
}, // Information about gender, age and role is already collected from preprogram
// We will however do a program evaluation, phrased in a way to encourage reflection
{
  prompt: "How likely would you be to recommend the Uprise program " + "to your family and friends?",
  extraText: "",
  type: "multi",
  batteryId: "survey",
  options: ["0 - Not likely to recommend", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "10 - Extremely likely"]
}, {
  prompt: "How would you rate module 1 (retraining thoughts)?",
  extraText: "",
  type: "multi",
  options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
  batteryId: "survey"
}, {
  prompt: "How would you rate module 2 (work-life balance)?",
  extraText: "",
  type: "multi",
  options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
  batteryId: "survey"
}, {
  prompt: "How would you rate module 3 (mindfulness)?",
  extraText: "",
  type: "multi",
  options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
  batteryId: "survey"
}, {
  prompt: "How would you rate module 4 (stress management)?",
  extraText: "",
  type: "multi",
  options: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
  batteryId: "survey"
}, {
  prompt: "How useful did you find the coaching calls?",
  extraText: "",
  type: "multi",
  batteryId: "survey",
  options: ["0 - Not useful", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "10 - Extremely useful"]
}, {
  prompt: "If you had a magic wand, and could change just one thing about the program, " + "what would it be, and why?",
  extraText: "",
  type: "single",
  optional: true,
  batteryId: "survey"
}, {
  prompt: "If you'd like to refer the program to one or more colleagues or friends, " + "please type their email addresses below. We will send an email saying that you've " + "completed Uprise and thought that they might like it too.",
  extraText: "",
  type: "single",
  optional: true,
  batteryId: "survey"
}, {
  prompt: "Lastly, if you'd like to leave a testimonial, you can do so here. " + "Please indicate if you're happy with being identified by company, position, or name, " + "otherwise we'll keep this information anonymous.",
  extraText: "",
  type: "single",
  optional: true,
  batteryId: "survey"
}]);

var analysis = function analysis(answers) {
  if (!answers) return null;
  var results = {};
  [utils.screeners.PSS_DEPRECATED, utils.screeners.WHO5, utils.screeners.ROI_HPQ_3, utils.screeners.workplaceQuestionnaire5].forEach(function (battery) {
    results = Object.assign(results, screenersImport.extractResults(questions, answers, battery));
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[i]);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};